export function defaultCard(hit, html, components) {
	const cardLabels = () => {
		const labels = [strl_vars.cpt_labels[hit.post_type]];
		const excludes = ['cbg-year', 'cbg-month'];
		const cardTaxonomies = Object.keys(strl_vars.cpt_taxonomies).filter((key) => `tax_${key}` in hit && !excludes.includes(key));

		cardTaxonomies.forEach((tax) => {
			hit[`tax_${tax}`].forEach((term) => {
				labels.push(term.name);
			});
		});

		return labels;
	};

	return html`
		<article
			class="group hover:[&_.label-background]:bg-primary-10 ${hit.featured_image
				? 'lg:grid-cols-[250px_auto]'
				: ''} relative overflow-clip rounded-md shadow-md lg:grid"
		>
			${hit.featured_image &&
			html`
				<header class="bg-image-fallback relative aspect-video lg:aspect-auto">
					<img src="${hit.featured_image}" alt="" class="image-fill rounded-r-md" />
				</header>
			`}
			<div class="group-hover:bg-primary-20 grid grid-cols-[1fr_auto] items-end bg-white p-7 transition-colors">
				<div class="flex flex-col">
					<div class="mb-3">
						<div class="flex flex-wrap gap-x-4 gap-y-2">
							${cardLabels().map((label, index) => {
								return html`<div
									class="text-secondary-140 ${index === 0
										? ' label-background bg-primary-20 px-1.5'
										: ''} flex items-center gap-1 rounded-sm text-[13px]"
								>
									<i class="fa-regular text-secondary fa-tag${index === 0 ? ' hidden!' : ''}"></i>
									${label}
								</div>`;
							})}
						</div>
					</div>

					<h3 class="h4 line-clamp-2 leading-7">${components.Highlight({ attribute: 'post_title', hit })}</h3>
					<p class="text-secondary-140/80 mt-3 mb-0 line-clamp-3 h-19 [&:has(span:empty)]:hidden">
						${components.Highlight({ attribute: 'settings-group_post-excerpt-content', hit })}
					</p>
				</div>

				<div class="hidden lg:block">
					<span
						class="btn group-hover:bg-secondary group-hover:border-secondary mt-4 ml-4 outline group-hover:text-white"
					>
						${strl_vars.read_more_text}
					</span>
				</div>
			</div>

			<a href="${hit.permalink}" target="_self" class="overlay-link">
				<span class="sr-only">${strl_vars.read_more_text}</span>
			</a>
		</article>
	`;
}
